module.exports = __webpack_public_path__ + "img/sidebar-battery-5.9e87481c.svg";